<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <BacktoPage path="/Masters"></BacktoPage>
          <Headerlayout :headertext="$t('Items.PackSizeMaster.List')"
            :contenttext="$t('Items.PackSizeMaster.TableHeaderContent')">
          </Headerlayout>
        </b-col>
      </b-row>
      <b-row class="py-3">
        <div v-if="windowWidth > 545">
          <SkeletonTableLoader :columns="headers" :loading="loading" />
          <div v-if="!loading">
            <MasterEmpty v-if="List.length === 0 && !loading" eheader="Pack Size Master" econtent="Pack Size Master"
              eimg="/src/assets/Img/icons/packsizemaster.svg" @createNew="IsAdd" />
            <div class="table-width-80">
              <Tableview v-if="List.length !== 0" :value="List" :paginator="true" class="p-datatable-gridlines"
                :rows="10" dataKey="Id" :rowHover="true" filterDisplay="menu" :loading="loading1"
                responsiveLayout="scroll" :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters"
                selectionMode="single" @row-click="" :exceldownload="true">
                <template v-slot:Add>
                  <span class="add">
                    <AddButton :btnname="$t('btn.plusaddnew')" class="float-rights my-3" @click="IsAdd()" />
                  </span>
                </template>
                <template v-slot:exceldownload>
                  <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                    PageName="Batch Master" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                </template>
                <template v-slot:status="{ data }">

                  <OrangeStatus name="InActive" v-if="data.IsActive == '0'" />
                  <GreenStatus name="Active" v-if="data.IsActive == '1'" />
                </template>
                <template v-slot:action="{ data }">
                  <span>

                    <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                      @click="toggle($event, data)" />
                  </span>
                </template>
              </Tableview>
            </div>
          </div>
        </div>
        <div v-if="windowWidth <= 545">
          <MobileLoader v-if="loading" v-for="item in 5" />
          <div v-if="!loading">
            <MasterEmpty v-if="List.length === 0 && !loading" eheader="Pack Size Master" econtent="Pack Size Master"
              eimg="/src/assets/Img/icons/packsizemaster.svg" @createNew="IsAdd" />
            <MobileViewCardHeader>
              <template v-slot:mobilecard>
                <div class="mobile-card" v-for="item in List">
                  <div class="d-flex align-items-center justify-content-between gap-2">
                    <div>
                      <p class="light-name">{{ item.Code }}</p>
                      <p class="name">{{ item.Name }}</p>
                    </div>
                    <div class="d-flex align-items-center">
                      <div>

                        <OrangeStatus name="InActive" v-if="item.IsActive == '0'" />
                        <GreenStatus name="Active" v-if="item.IsActive == '1'" />
                      </div>
                      <i class="pi pi-ellipsis-v" @click="toggle($event, item)"></i>
                    </div>
                  </div>
                  <p class="small-name">{{ item.StoreName }}</p>
                </div>
              </template>
            </MobileViewCardHeader>

          </div>
        </div>
        <Packcreation v-model:trigger="showDialog" v-if="showDialog" v-model:selected-item="editItems"
          @load="IsShow(), (showDialog = false)" @close="showDialog = false" @loaderhide="loading = false"
          @loadershow="loading = true" :OperationID="ObjOperationId" :EntityId="EntityData.EntityId" />
      </b-row>


      <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
      <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
        :content="$t('confirmation.editcontent')" />
      <ActivatedSuccessfully :visible="pop.activatepop" @ok="closetrigger()" />
      <InActivatedSuccessfully :visible="pop.inactivepop" @ok="closetrigger()" />
      <DeleteConfirmationVue :DeleteModel="Deletemodel" :content="contentdel" @yes="IsDelete(dataEdit)"
        @no="Deletemodel = false" />
      <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
      <Mapping :content="ContentName" :visible="MappingPopup" @ok="closeMapping()" />

    </b-container>
  </div>
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, h, onMounted, onUnmounted } from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";



import Packcreation from "../../../Masters/Items/PackSizeMaster/PackSizeCreation.vue";
import PacksizeService from "../../../../Service/PackSizeService";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import { FilterMatchMode, FilterOperator } from "primevue/api";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import Mapping from "../../../../../../components/FormComponents/Mapping.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import ActivatedSuccessfully from "../../../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../../../components/FormComponents/InActivateSuccessfully.vue";

import MastersService from "../../../../Service/MastersService";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../Service/AccessControl";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";

export default defineComponent({
  components: {
    BacktoPage,
    Headerlayout,
    Packcreation,


    Tableview,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    EditConfirmation,
    Mapping,
    MasterEmpty,
    Loader,
    ActivatedSuccessfully,
    InActivatedSuccessfully,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    ExportOption,
  },
  setup() {
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });
    const toast = useToast();
    const packsize = ref();
    let loading1 = ref(false);
    const showDialog = ref(false);
    const editItems = ref();
    const Editmodel = ref(false);
    const { t } = useI18n();
    const Deletemodel = ref(false);
    const rowFocus = ref(false);
    let deletepop = ref(false);
    let MappingPopup = ref(false);
    let List: any = ref([]);
    let loading = ref(false);
    let ExportOption = ref("");
    let ExportList = ref([]);
    let ContentName = ref("");

    const pop = ref({
      activatepop: false,
      inactivepop: false,
    });
    const dataEdit = ref();
    const contentdel = ref("");
    let InActivevisible = ref(false);
    let Activevisible = ref(false);
    const datas = ref();
    const menu = ref();
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Code: { value: null, matchMode: FilterMatchMode.IN, options: List },
      Name: { value: null, matchMode: FilterMatchMode.IN, options: List },
      Qty: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ActiveStatus: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      CreatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },

      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    const headers = [
      {
        header: t('Items.PackSizeMaster.sno'),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t('Items.PackSizeMaster.Code'),
        field: "Code",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t('Items.PackSizeMaster.Name'),
        field: "Name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t('Items.PackSizeMaster.Qty'),
        field: "Qty",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor right_td",
        class: "smallwidth"
      },
      {
        header: t('Items.PackSizeMaster.Status'),
        field: "ActiveStatus",
        fieldDisplay: "false",
        slot: "status",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor",
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    const globalFilterFields = ref(headers.map((col) => col.field));

    const handleClick = () => {
      packsize.value.clear();
    };

    const IsAdd = () => {
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        showDialog.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };
    function toggle(event, data) {
      debugger;
      console.log(event);
      if (data.IsActive == 1) {
        InActivevisible.value = true;
        Activevisible.value = false;
      } else {
        InActivevisible.value = false;
        Activevisible.value = true;
      }

      datas.value = data;
      menu.value.toggle(event);
    }

    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: InActivevisible,
            command: async () => {
              IsConfirmEdit(datas.value);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              IsConfirmDel(datas.value, 0);
            },
          },

          {
            label: "Active",
            icon: "editicon pi pi-check-circle",
            visible: Activevisible,
            command: async () => {
              IsConfirmDel(datas.value, 1);
            },
          },
          {
            label: "InActive",
            icon: "deleteicon pi pi-minus-circle",
            visible: InActivevisible,
            command: async () => {
              IsConfirmDel(datas.value, 2);
            },
          },
        ],
      },
    ]);


    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        const response = await PacksizeService.getlistdata();
        let count = 0;
        response["result"] = response["result"]
          .filter((items) => items.HospitalId == usersData.OrganizationId)
          .map((item) => {
            item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
            count = count + 1;
            item.RowNumber = count;

            return item;
          });

        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log("ContactTable Data", List.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }



    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    onMounted(() => {
      debugger;
      window.addEventListener("resize", handleResize);

      document.addEventListener("keydown", onKeyUp);
      FunctionRights();

      IsShow();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    async function FunctionRights() {
      //
      debugger;
      const response = await MastersService.CheckMenuRights(
        EntityData.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
    }

    //TableView
    async function IsShow() {
      loading.value = true;
      try {
        const response = await PacksizeService.getlistdata();
        let count = 0;
        response["result"] = response["result"]
          .filter((items) => items.HospitalId == usersData.OrganizationId)
          .map((item) => {
            item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
            count = count + 1;
            item.RowNumber = count;

            return item;
          });

        List.value = response["result"];
        console.log(List.value);
        loading.value = false;
      } catch (error) {
        loading.value = false;
        console.log(error);
      }
    }
    function IsEdit(data) {
      debugger;
      editItems.value = data;
      Editmodel.value = false;
      showDialog.value = true;
    }
    function IsConfirmEdit(data) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Edit");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    //Delete-Popup
    async function IsConfirmDel(data, Status) {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Delete");
      if (permissionResult.hasPermission) {
        data.ActiveStatus = Status;
        dataEdit.value = data;
        Editmodel.value = false;
        if (Status == 1) {
          contentdel.value = t('confirmation.activecontent');
        } else if (Status == 2) {
          contentdel.value = t('confirmation.inactivecontent');
        } else {
          contentdel.value = t('confirmation.deletecontent');
        }
        Deletemodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    // Map Popup-Close
    function closeMapping() {
      debugger;
      MappingPopup.value = false;
      pop.value.activatepop = false;
      pop.value.inactivepop = false;
      Deletemodel.value = false;
    }
    //Delete Values in Table
    async function IsDelete(data) {
      loading.value = true;
      debugger;
      try {
        let result: any = "";
        if (data.ActiveStatus == 0) {
          result = await PacksizeService.deletedata(data.Id);
        } else {
          let status = data.ActiveStatus == 1 ? true : false;
          result = await PacksizeService.active(data.Id, status);
        }
        loading.value = false;

        // const result = await PacksizeService.deletedata(data.Id, data.ActiveStatus);
        let message = result["ErrorInfo"].ErrorCode;

        if (result["result"] != "False" && message == null) {
          ContentName.value = result["result"];
          MappingPopup.value = true;
        } else if (message == null) {
          if (data.ActiveStatus == 1) {
            pop.value.activatepop = true;
          } else if (data.ActiveStatus == 2) {
            pop.value.inactivepop = true;
          } else {
            deletepop.value = true;
          }
          Deletemodel.value = false;
          rowFocus.value = false;
          IsShow();
        }
      } catch (error) {
        loading.value = false;
        console.log(error);
      }
    }
    function RowClick(event: any) {
      debugger;
      Editmodel.value = true;
      rowFocus.value = true;
      dataEdit.value = event.data;
    }
    //Deleted Sucessfully Popup-Close
    function closetrigger() {
      deletepop.value = false;
      pop.value.activatepop = false;
      pop.value.inactivepop = false;
    }
    function onKeyUp(event: any) {
      debugger;

      console.log(dataEdit.value);
      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true &&
        Deletemodel.value == false &&
        showDialog.value == false
      ) {
        // IsEdit(dataEdit.value)
        Editmodel.value = true;
      } else if (
        event.altKey &&
        event.key == "n" &&
        Editmodel.value == false &&
        Deletemodel.value == false
      ) {
        IsAdd();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        IsDelete(dataEdit.value);
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit(dataEdit.value);
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (
        event.key == "d" &&
        rowFocus.value == true &&
        showDialog.value == false &&
        Editmodel.value == false
      ) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      } else if (event.key == "Escape" && MappingPopup.value == true) {
        MappingPopup.value = false;
        Deletemodel.value = false;
      }
    }
    return {
      EntityData,
      ObjOperationId,
      closeMapping,
      headers,
      List,
      handleClick,
      IsShow,
      packsize,
      IsDelete,
      loading1,
      globalFilterFields,
      filters,
      IsConfirmDel,
      Deletemodel,
      closetrigger,
      showDialog,
      editItems,
      Editmodel,
      rowFocus,
      deletepop,
      IsAdd,
      IsConfirmEdit,
      RowClick,
      IsEdit,
      dataEdit,
      MappingPopup,
      ContentName,
      loading,
      toggle,
      itemListed,
      menu,
      contentdel,
      pop,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
    };
  },
});
</script>
<style lang="scss" scoped>
.mobileroomname {
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-top: -7px;
}

.mobilestorename {
  font-size: 14px;
  color: #999999;
}
</style>
